// extracted by mini-css-extract-plugin
export default {"list":"choose-list_list__Rr1TA","text":"choose-list_text__1y8mf"};